import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { Article } from '../../models/article.model';
import { ArticlesService } from '../../services/articles.service';
import { CategoriesService } from '../../services/categories.service';
import { Category } from '../../models/category.model';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-articles',
  imports: [RouterLink, DatePipe],
  templateUrl: './articles.component.html',
  styles: `
    .card {
      --bs-card-border-radius: 0;
      --bs-card-inner-border-radius: 0;
    }
  `
})
export class ArticlesComponent implements OnInit {
  articles: Article[] = [];
  categories: Category[] = [];
  paramsArticles = { category_id: '' };
  categoryId?: number;
  loading = true;

  private articlesService = inject(ArticlesService);
  private categoriesService = inject(CategoriesService);
  private route = inject(ActivatedRoute);

  ngOnInit() {
    this.route.queryParamMap.subscribe((params) => {
      this.paramsArticles.category_id = params.get('categoria') || '';
      if (this.paramsArticles.category_id) {
        this.categoryId = parseInt(this.paramsArticles.category_id, 10);
      }
      this.getArticles();
      this.getCategories();
    });
  }

  getArticles() {
    this.loading = true;
    this.articles = [];
    this.articlesService.getAll(this.paramsArticles).subscribe((data) => {
      this.articles = data.data.records;
      this.loading = false;
    });
  }

  getCategories() {
    this.categoriesService.getAll().subscribe((res) => {
      this.categories = res.data;
      this.getQuantityItems(this.categories);
    });
  }

  getQuantityItems(categories: Category[]) {
    categories.forEach((category) => {
      this.articlesService.getAll({ category_id: category.id }).subscribe({
        next: (res) => {
          category.quantityItems = res.data.records.length;
        },
        error: () => {
          category.quantityItems = 0;
        }
      });
    });
  }

  get filterCategory(): Category[] {
    if (this.categoryId) {
      return this.categories.filter(
        (category) => category.id !== this.categoryId
      );
    }
    return this.categories;
  }

  getCategoryName(categoryId: number): string {
    const category = this.categories.find((c) => c.id === categoryId);
    return category ? category.name : 'N/A';
  }
}
